import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { primaryMailboxSearchScope, archiveMailboxSearchScope, compareSearchScope, } from 'owa-search-service';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
import { PRIMARY_DUMPSTER_DISTINGUISHED_ID, ARCHIVE_DUMPSTER_DISTINGUISHED_ID } from 'owa-folders';
/**
 * Returns a flag indicating whether the table is the dumpster search table
 * @param tableQuery - the table query
 * @return whether the table is the dumpster search table
 */
export default function isDumpsterSearchTable(tableQuery) {
    var searchTableQuery = tableQuery;
    return isFolderUnderArchiveRoot(searchTableQuery.folderId)
        ? compareSearchScope(searchTableQuery.searchScope, archiveMailboxSearchScope({
            folderId: folderNameToId(ARCHIVE_DUMPSTER_DISTINGUISHED_ID),
            kind: "ArchiveMailbox" /* ArchiveMailbox */,
        }))
        : compareSearchScope(searchTableQuery.searchScope, primaryMailboxSearchScope({
            folderId: folderNameToId(PRIMARY_DUMPSTER_DISTINGUISHED_ID),
            kind: "PrimaryMailbox" /* PrimaryMailbox */,
        }));
}
//# sourceMappingURL=isDumpsterSearchTable.js.map